import './BreadOrderDashboard.css'
import { useEffect, useState } from 'react';
import BreadOrderCard from '../BreadOrderCard/BreadOrderCard';

export default function BreadOrderDashboard({ breadOrders }) {
    const [orders, setOrders] = useState([]);

    useEffect(() => {
        const today = new Date();
        const tomorrow = new Date();
        tomorrow.setDate(today.getDate() + 1);

        const todayStr = today.toISOString().split('T')[0];
        const tomorrowStr = tomorrow.toISOString().split('T')[0];

        const todayOrders = breadOrders.filter(order => order.date === todayStr);
        const tomorrowOrders = breadOrders.filter(order => order.date === tomorrowStr);

        const combinedOrders = [...todayOrders, ...tomorrowOrders];

        const pendingOrders = combinedOrders.filter(order => order.status === 'pending');
        const readyOrders = combinedOrders.filter(order => order.status !== 'pending');

        const finalList = [...pendingOrders, ...readyOrders];

        setOrders(finalList);
    }, [breadOrders]);

    return (
        <div className='bread-order-dashboard'>
            <div>
                {orders.length === 0 && (
                    <p className='no-orders-found'>🥐 No hay ordenes para hoy 🥐</p>
                )}
                <div className='bread-order-dashboard-today'>
                    {orders.map((order) => (
                        <BreadOrderCard key={order.id} order={order} />
                    ))}
                </div>
            </div>
        </div>
    );
}